import { render, staticRenderFns } from "./AdvisorWizard.vue?vue&type=template&id=98a1e99a"
import script from "./AdvisorWizard.vue?vue&type=script&lang=js"
export * from "./AdvisorWizard.vue?vue&type=script&lang=js"
import style0 from "./AdvisorWizard.vue?vue&type=style&index=0&id=98a1e99a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports